<template>
  <div name="csv-exporter">
    <div class="exporter-box">
      <p class="minor-btn-inactive" v-if="dataRows.length <= 0"><i class="space fa fa-cloud-download"></i>Export CSV</p>
      <div class="minor-btn-active" v-if="dataRows.length > 0" @click="exportCSV()"><i class="space fa fa-cloud-download"></i>Export CSV</div>
      <a class="hidden" ref="csvURI" :href="uri" download="result.csv"></a>
    </div> 
  </div>
</template>

<script>
var $ = require('jquery')
$.csv = require('jquery-csv')
var FileSaver = require('file-saver')

export default {
  name: 'csv-exporter',
  data () {
    return {
      uri: ''
    }
  },
  props: {
    dataRows: {
      type: Array,
      required: true
    },
    columns: {
      required: true,
      default () {
        return {
          key: '',
          name: ''
        }
      }
    }
  },
  methods: {
    exportCSV () {
      let newDataRows = []
      let keys = Object.keys(this.dataRows[0])
      let columnKeys = this.columns.map((column) => column.key)
      for (let dataRow of this.dataRows) {
        let newDataRow = {}
        for (let key of keys) {
          let columnIndex = columnKeys.indexOf(key)
          if (columnIndex > -1) {
            newDataRow[this.columns[columnIndex].name] = '\t' + dataRow[key]
          }
        }
        newDataRows.push(newDataRow)
      }
      var csv = $.csv.fromObjects(newDataRows)
      var blob = new global.Blob([csv], { type: 'text/csv;charset=utf-8,%EF%BB%BF' })
      FileSaver.saveAs(blob, 'result.csv')
    }
  }
}
</script>

<style lang="scss">
.exporter-box {
  float: right;
  margin: 10px 0 10px 10px;

  @media (max-width: 768px) {
    float: left;
  }

  .minor-btn-active {
    height: 25px;
    border-radius: 2px;
    padding: 4px 8px;
    background: #7d7d7d;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
    cursor: pointer;
    color: #FFF;

    &:hover {
      box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);
      color: #FFF;
    }
  }

  .minor-btn-inactive {
    height: 25px;
    border-radius: 2px;
    padding: 4px 8px;
    background: #E0E0E0;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);  
    cursor: not-allowed;
    color: #FFF;

    &:hover {
      color: #FFF;
    }
  }

  .space {
    margin-right: 8px;
  }
}

</style>


// WEBPACK FOOTER //
// csvExporter.vue?1b959688